var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import Waitting from './details/Waitting.vue';
import Login from './details/Login.vue';
import Top from './details/Top.vue';
import getAddress from '../../ts/getAddress';
var Wallet = /** @class */ (function (_super) {
    __extends(Wallet, _super);
    function Wallet() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.background_img = './static/img/background.png';
        return _this;
    }
    Wallet.prototype.mounted = function () {
    };
    Wallet = __decorate([
        Component({
            name: 'wallet',
            data: function () { return ({
                getAddress: new getAddress(),
                version: 'ver1.4.6',
                address: '',
                private_key: '',
                public_key: '',
                login_page: false,
                waitting_page: false,
                top_page: false,
            }); },
            components: { Login: Login, Waitting: Waitting, Top: Top },
            mounted: function () {
                // ビュー全体が再レンダリングされた後にのみ実行されるコード
                this.$nextTick(function () {
                    this.$data.address = this.$data.getAddress.address;
                    this.$data.private_key = this.$data.getAddress.privateKey;
                    this.$data.public_key = this.$data.getAddress.publicKey;
                    this.$data.login_page = this.$data.getAddress.login_page;
                    this.$data.waitting_page = this.$data.getAddress.waitting_page;
                    this.$data.top_page = this.$data.getAddress.top_page;
                    console.log(this.$data.getAddress.waitting_page);
                    console.log("========-");
                });
            }
        })
    ], Wallet);
    return Wallet;
}(Vue));
export default Wallet;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/pages/Wallet.vue
// module id = 154
// module chunks = 1